import { ISSRPageData } from '@interfaces'
import { ObjectService } from '@services'
import { ObjectTemplate } from '@templates'
import { createNavLink } from '@utils'
import { useRouter } from 'next/router'

const ArtCollectionWorkDetailScreen = ({ pageData, global }: ISSRPageData) => {
  const { locale } = useRouter()
  const collectionsHref = createNavLink('collections', locale)

  return (
    <ObjectTemplate
      global={global}
      pageData={pageData}
      headerLeftNavButtonLabel={
        pageData.data?.classification?.value ?? ''
      }
      headerLeftNavButtonHref={
        pageData.data?.sourceId?.value && pageData.slug
          ? `${collectionsHref}/${pageData.slug}#collection-${pageData.data.sourceId.value}`
          : collectionsHref
      }
    />
  )
}

export default ArtCollectionWorkDetailScreen

/**
 * slug is collection sourceId
 * object is object of collection sourceId
 */
interface ISSRProps {
  query: {
    slug: string
    object: string
  }
  locale: string
}

export async function getServerSideProps({ query, locale }: ISSRProps) {
  const { object, slug } = query
  const pageData = {
    data: null,
    error: null,
    slug: null,
  }

  try {
    const collection = await ObjectService.getObjectDetailPage(
      object,
      locale,
      'collection',
      slug
    )

    pageData.data = collection
    pageData.slug = slug
  } catch (err) {
    if (err instanceof Error) {
      pageData.error = { message: err.message }
    }
  }

  if (!pageData.data && !pageData.error) {
    pageData.error = { message: 'Object not found' }
  }

  return {
    props: { pageData, query },
  }
}
